module.exports = __webpack_public_path__ + "static/Hero-bb6f4149d1b3a0be39ca437b65bef9fa.png";